import { SortBy } from "types";

export const initialSortValue: SortBy = { pageIndex: 0 };
export const initialDescendingSortValue: SortBy = {
	pageIndex: 0,
	isDescending: true,
};

export const tidUnassignedFilterInitialValues = {
	number: "",
	mid: "",
	merchantName: "",
	agentOffice: "",
	agentName: "",
	terminalNumber: "",
};

export const tidInProgressFilterInitialValues = {
	number: "",
	mid: "",
	merchantName: "",
	agentOffice: "",
	agentName: "",
	terminalNumber: "",
	assignedTo: null,
};

export const tidPendedFilterInitialValues = {
	number: "",
	mid: "",
	merchantName: "",
	agentOffice: "",
	agentName: "",
	terminalNumber: "",
	pendStatus: null,
	pendedTo: null,
	assignedTo: null,
};

export const tidCompleteFilterInitialValues = {
	...tidUnassignedFilterInitialValues,
};

export const tidQaUnassignedFilterInitialValues = {
	...tidUnassignedFilterInitialValues,
};

export const tidQaInProgressFilterInitialValues = {
	...tidInProgressFilterInitialValues,
};
export const tidQaCompleteFilterInitialValues = {
	...tidUnassignedFilterInitialValues,
};
